import React from 'react';
import { Provider } from 'react-redux';
import propTypes from 'prop-types';

import AppBase from '@common/ui/AppBase';
import analytics from '@profile/analytics';
import Profile from '@profile/pages/Profile';

import ReferralProvider from '~referral/providers/ReferralProvider';
import store from './store';
import '~referral/index.scss';
import '~profile_stats/index.scss';

function App({ profileACL, ...remainingProps }) {
  return (
    <AppBase renderSingletons>
      <Provider store={store}>
        <ReferralProvider analytics={analytics}>
          <Profile
            profileACL={profileACL}
            {...remainingProps}
          />
        </ReferralProvider>
      </Provider>
    </AppBase>
  );
}

App.propTypes = {
  profileACL: propTypes.object.isRequired,
};

export default App;
